<template>
  <div>
    <!-- <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="hee hee"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="800px"
        ref="html2Pdf"
    >
    <section slot="pdf-content"> -->
    <div class="navBar" id="navBar" ref="testHtml" @mouseleave="handleCartMouseOut($event)">
      <header class="site-header">
        <div class="nav_top" v-if="!isMobile">
          <div class="logo-container">
            <div class="logo" style="cursor: pointer" @click="goToHome()">
              <img src="../assets/img/logo.jpg" />
            </div>
            <!-- </router-link> -->
            <!-- Bill warehouse changes -->
            <!-- <div class="search" style="marginRight: 10px; fontFamily: Source Sans Pro">
                <a href="javascript:void(0)" @click="setLocation()">
                 <i style="color: white; fontSize: 20px" class="fa fa-map-marker-alt" ></i>
                 <span v-if="this.warehouseLocation && this.warehouseLocation !== 'All'" class="mobile_hide" style="marginLeft: 10px; textAlign: left">{{this.warehouseLocation}}</span>
                 <span v-else class="mobile_hide" >{{ $t('none') }}</span>
               </a>
            </div> -->
            <div
              v-if="windowWidth > 411"
              style="cursor: pointer; fontsize: 20px; fontweight: 800"
              @click="goToHome()"
              class="logo2"
            >
              <!-- <img src="../assets/img/english-logo.png" /> -->
              {{ $t("company_name") }}
            </div>
          </div>
          <!-- <div class="navbar-select" v-if="loggedIn">
            <el-select v-model="company_id" :placeholder="$t('pleaseSelect')" @change="changeCompany">
              <el-option
                v-for="item in companyAll"
                :key="item.id"
                :label="item.Name"
                :value="item.id"
                :disabled="company_disabled"
                >
              </el-option>
            </el-select>
          </div>
          <div class="navbar-select" v-else>
            <el-select v-model="company_id" :placeholder="$t('pleaseSelect')" @change="changeCompany">
              <el-option
                v-for="item in companyAll"
                :key="item.id"
                :label="item.guestName"
                :value="item.id"
                :disabled="company_disabled"
                >
              </el-option>
            </el-select>
          </div> -->
          <div class="navbar-items" v-if="windowWidth > 411">
            <ul>
              <!-- <li v-if="!topDisabled" style="margin-right: 7px">
                <div class="shipping-button" @click="toggleShippingMethodModalVisibility(true)">
                  <span v-if="shippingMethodGlobal === 'Delivery'">{{ $t('delivery') }}</span>
                  <span v-if="shippingMethodGlobal === 'Pickup'">{{ $t('pickup') }}</span>
                  <i class="fa fa-caret-down" style="margin-left: 10px" aria-hidden="true"></i>
                </div>
              </li>

              <li v-if="topDisabled" style="margin-right: 7px">
                <div class="shipping-button" style="cursor: not-allowed;">
                  <span v-if="shippingMethodGlobal === 'Delivery'">{{ $t('delivery') }}</span>
                  <span v-if="shippingMethodGlobal === 'Pickup'">{{ $t('pickup') }}</span>
                  <i class="fa fa-caret-down" style="margin-left: 10px" aria-hidden="true"></i>
                </div>
              </li>

              <li v-if="!topDisabled" style="margin-left: 7px; margin-right: 10px">
                <div v-if="shippingMethodGlobal === 'Delivery'" class="zipcode-button"
                  @click="toggleZipcodeModalVisibility(true)">
                  <span v-if="userZip">{{ userZip }}</span>
                  <span class="ent-zip" v-if="!userZip">{{ $t('zip_code') }}</span>
                </div>
                <div v-if="shippingMethodGlobal === 'Pickup'" class="zipcode-button" @click="setLocation(true)">
                  <span
                    v-if="this.warehouseLocation && this.warehouseLocation !== 'All'">{{ this.warehouseLocation }}</span>
                  <span v-else>{{ $t('select_store') }}</span>
                </div>
              </li>

              <li v-if="topDisabled" style="margin-left: 7px; margin-right: 10px">
                <div v-if="shippingMethodGlobal === 'Delivery'" class="zipcode-button" style="cursor: not-allowed;">
                  <span v-if="userZip">{{ userZip }}</span>
                  <span v-if="!userZip">{{ $t('enter_zip_code') }}</span>
                </div>
                <div v-if="shippingMethodGlobal === 'Pickup'" class="zipcode-button" style="cursor: not-allowed;">
                  <span
                    v-if="this.warehouseLocation && this.warehouseLocation !== 'All'">{{ this.warehouseLocation }}</span>
                  <span v-else>{{ $t('select_store') }}</span>
                </div>
              </li> -->

              <!-- <li v-if="!loggedIn">
                <div
                  style="cursor: pointer"
                  @click="toggleLoginModalVisibility(true)"
                >
                  <a>
                    如果放开login的注释，下面这一行要注释
                    <span class="nav-item" style="width: 150px">{{ $t('sign_up') }}/{{ $t('log_in') }}</span>
                    <span class="nav-item" style="width: 150px">{{
                      $t("log_in")
                    }}</span>
                  </a>
                </div>
              </li>
              <li v-else @click="signOut">
                <a>
                  <span class="nav-item">{{ $t("Logout") }}</span>
                </a>
              </li> -->
              <!-- <li v-if="$route.path !== '/login'" @click="signOut">
                <a>
                  <span class="nav-item">{{ $t("Logout") }}</span>
                </a>
              </li> -->
              <li v-if="$route.path !== '/login'">
                <!-- <a> -->
                  <span v-if="userDetails" class="nav-item" style="margin-left: 10px;">
                    <span v-if="userDetails.LastName || userDetails.FirstName">  {{ userDetails.FirstName }} {{ userDetails.LastName }}</span>
                    <span v-else>{{ userDetails.username }}</span>
                  </span>
                <!-- </a> -->
              </li>
              <li v-if="$route.path !== '/login'" @click="signOut">
                <a>
                  <span class="nav-item">{{ $t("Logout") }}</span>
                </a>
              </li>
              <li>
                <a class="pointer" @click="clickContactUs">
                  {{ $t("contact_us") }}
                </a>
              </li>
              <li>
                <el-button
                  class="print-button"
                  @click="clickPrint"
                  v-if="$route.path === '/collections'"
                >
                  {{ $t("print") }}
                </el-button>
              </li>
              <li>
                <el-button
                  class="print-button"
                  @click="clickShare"
                  v-if="$route.path === '/collections'"
                >
                  {{ $t("share") }}
                </el-button>
              </li>
              <li>
                <a @click="langChanged">
                  <!-- <span v-if="this.$i18n.locale == 'en'" class="nav-item">EN</span>
                  <span v-if="this.$i18n.locale == 'ch'" class="nav-item">繁體中文</span> -->
                  <span class="nav-item" style="width: 85px">中文 / EN</span>
                </a>
              </li>
              <!-- <li>
                <div class="track-button-placeholder"></div>
              </li> -->
            </ul>
          </div>
        </div>
        <!-- <div class="nav" v-if="showNavBottom"> -->
        <div class="nav" :style="isMobile?'margin-top:65px':''" v-if="$route.path !== '/login'">
          <div class="nav-container">
            <!-- <div class="product-container" @click="handleGroupTab">
              <div :class="groupTab ? 'rotate' : ''">
                <font-awesome-icon
                  icon="bars"
                  :style="{ color: '#b6b6b6', fontSize: '26px' }"
                  :class="groupTab ? 'rotate' : 'rotate-back'"
                />
              </div>
              <a>
                <p class="all-products">{{ $t("all_categories") }}</p>
              </a>
            </div> -->
            <div class="product-container" @click="goToHome()">
              <div :class="groupTab ? 'rotate' : ''">
                <img :style="{cursor: 'pointer', height: '35px'}" src="../assets/img/breadcrumb-home.png" @click="goToHome()">
                <!-- <font-awesome-icon
                  icon="bars"
                  :style="{ color: '#b6b6b6', fontSize: '26px' }"
                  :class="groupTab ? 'rotate' : 'rotate-back'"
                /> -->
              </div>
              <!-- <a>
                <p class="all-products">{{ $t("all_categories") }}</p>
              </a> -->
            </div>
            <div class="search-container">
              <div class="search-bar">
                <input
                  type="text"
                  :placeholder="$t('search')"
                  class="navbar-search"
                  v-model="searchTerm"
                  v-on:keyup.enter="searchProduct"
                />
                <div
                  style="
                    height: 30px;
                    width: 30px;
                    borderradius: 15px;
                    backgroundcolor: black;
                    display: flex;
                    justifycontent: center;
                    alignitems: center;
                  "
                  class="fa-hover"
                  @click="searchProduct"
                >
                  <font-awesome-icon
                    icon="search"
                    :style="{ color: 'black', fontSize: '30px' }"
                  />
                </div>
              </div>
            </div>
            <div class="icon-container">
              <div class="icon-holder">
                <div @click="goToAccount(null)">
                  <img class="icon-img" :src="accountImage" @mouseover="accountImage = accountImages.hover"
                    @mouseleave="accountImage = accountImages.default" />
                  <span class="icon-h-name">{{ $t('Account') }}</span>
                </div>
            <!-- <a class="icon-a">Account</a> -->
              </div>
              <!-- <div class="icon-holder" @click="goToAccount('favourites')">
                <img class="icon-img" :src="favoriteImage" @mouseover="favoriteImage = favoriteImages.hover"
                  @mouseleave="favoriteImage = favoriteImages.default" />
                <span class="icon-h-name">{{ $t('favourites') }}</span>
            <a class="icon-a">Favorite</a>
            </div> -->
            <div class="icon-holder cart-container" id="cart-icon">
              <!-- <div class="icon-cont" @mouseenter="handleCartMouseEnter($event)" v-if="!cartModalVisible && cart > 0">
                <span class="count">{{ cart }}</span>
              </div> -->
              <img class="icon-img" @mouseenter="handleCartMouseEnter($event)"
                v-if="!cartModalVisible" src="../assets/img/navbarCart.svg" />
              <img class="icon-img" v-else src="../assets/img/navbarCartHover.svg" />
              <span class="icon-h-name">{{ $t('cart') }}</span>
              <!-- <a class="icon-a totalItemsCount">{{this.generateTotalItems()}}</a> -->
              <span class="cart-count">{{this.generateTotalItems()}}</span>
            </div>
          </div>
            <!-- <div class="icon-holder" id="cart-icon">
              <img class="icon-img" @mouseenter="handleCartMouseEnter($event)"
                v-if="!cartModalVisible && cart === 0" src="../assets/img/navbarCart.svg" />
              <img class="icon-img" v-else src="../assets/img/navbarCartHover.svg" />
              <span class="icon-h-name">{{ $t('cart') }}</span>
            </div> -->
            <cartModal
              v-if="cartModalVisible"
              v-bind:cartItems="
                this.loggedIn
                  ? this.cartProductsList.Sales_Order_Lines
                  : this.cartProductsList
              "
            >
            </cartModal>
          </div>
        </div>
      </header>
      <div
        :style="
          this.phoneNav
            ? ' transform: translateY(-24px);'
            : 'transform: translateY(-100%);'
        "
        class="mobile-nav-wrapper hidden-md-and-up"
        :class="[
          MunchiesShow ? 'sub_nav__is_open' : '',
          this.phoneNav ? 'mobile_nav_wrapper_show' : '',
        ]"
      >
        <div
          class="mobile-nav"
          v-for="(group, index) in allGroups"
          data-index="index"
          :key="index"
        >
          <div
            class="mobile-nav__item"
            :class="MunchiesShow ? 'is_active' : ''"
          >
            <p @click="mobileNavGo(group.ProductGroup_id)">
              <span class="mobile-nav__label">{{ group.Name }}</span>
              <i class="el-icon-arrow-right"></i>
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="groupTab"
        class="cascade"
        @mouseleave="handleProductsMouseLeave($event)"
      >
        <el-cascader-panel
          v-model="dropDownSelection"
          :options="groupOptions"
          :props="{ expandTrigger: 'hover' }"
        >
          <template slot-scope="{ node, data }">
            <span v-if="$i18n.locale == 'en'" @click="navigateHeader(data)">{{
              data.label
            }}</span>
            <span v-if="$i18n.locale == 'ch'" @click="navigateHeader(data)">{{
              data.description
            }}</span>
          </template>
        </el-cascader-panel>
      </div>

      <transition name="modal" v-if="loginModalVisibilityLocal">
        <div class="modal-mask" @click="toggleLoginModalVisibility(false)">
          <div class="modal-wrapper">
            <div class="modal-container3" @click.stop>
              <loginNew></loginNew>
            </div>
          </div>
        </div>
      </transition>

      <transition name="modal" v-if="registerModalVisibilityLocal">
        <div class="modal-mask" @click="toggleRegisterModalVisibility(false)">
          <div class="modal-wrapper">
            <div class="modal-container3" @click.stop>
              <registerNew></registerNew>
            </div>
          </div>
        </div>
      </transition>

      <!--  商品详情页点击左侧大图片会展示本内容  -->
      <transition name="modal" v-if="this.productDetailImgVisibility">
        <div class="modal-mask" @click="toggleImgModalVisibility(false, null)">
          <div class="modal-wrapper">
            <div class="modal-container4" @click.stop>
              <div class="modal-store-close">
                <img
                  @click="toggleImgModalVisibility(false, null)"
                  src="../assets/img/closemodal.png"
                  alt=""
                />
              </div>
              <!--              <img :src="this.productDetailImg" alt="">-->
              <afwSwiper :current="this.productDetailImg"></afwSwiper>
            </div>
          </div>
        </div>
      </transition>

      <transition name="modal" v-if="this.printShareVisibility">
        <div class="modal-mask" @click="togglePrintShareVisibility(false, '')">
          <div class="modal-wrapper">
            <div class="modal-container-printshare" @click.stop>
              <!-- <div class="modal-share-title">
                Share Catelog
              </div> -->
              <div class="modal-link">
                {{ this.printShareLink }}
                <!-- <img
                  @click="togglePrintShareVisibility(false)"
                  src="../assets/img/closemodal.png"
                  alt=""
                /> -->
              </div>
              <div style="width: 100%; display: flex; justify-content: center;">
                <p v-clipboard:copy="this.printShareLink" v-clipboard:success="copy" class="bottom-copy">{{ $t('copy') }}</p>
              </div>
              <!--              <img :src="this.productDetailImg" alt="">-->
              <!-- <afwSwiper :current="this.productDetailImg"></afwSwiper> -->
            </div>
          </div>
        </div>
      </transition>

      <!-- zipcode modal -->
      <!-- <modal1 v-if="this.showModal" @close="this.showModal = false" header="Where Do We Deliver To?" ></modal1> -->

      <!-- show warehhouse modal -->
      <transition
        name="modal"
        v-if="this.showModal && !loggedIn && warehouseSelectionModalVisibility"
      >
        <div class="modal-mask" @close="this.toggleModal(false)">
          <div class="modal-wrapper">
            <div class="modal-container9" @click.stop>
              <p class="store-title">{{ $t("selectCompany") }}</p>
              <div
                class="store-button-container"
                v-for="(item, index) in companyAll"
                data-index="index"
                :key="index"
              >
                <button class="store-button" @click="selectLocation(item.id)">
                  {{ $t(item.guestName) }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <!-- <transition name="modal" v-if="orderModalVisible">
        <div class="modal-mask" @click="toggleOrderModal(false)">
          <div class="modal-wrapper">
            <div class="deliveryModal-container" @click.stop>
              <deliveryModal v-if="orderModalVisible"></deliveryModal>
            </div>
          </div>
        </div>
      </transition> -->

      <!-- <transition name="modal" v-if="guestCheckoutModalVisiblity">
        <div class="modal-mask" @click="toggleGuestCheckoutVisiblity(false)">
          <div class="modal-wrapper">
            <div class="modal-container3" @click.stop>
              <guestCheckout v-if="guestCheckoutModalVisiblity"></guestCheckout>
            </div>
          </div>
        </div>
      </transition> -->

      <!-- <transition name="modal" v-if="shippingMethodModalVisibility">
        <div class="modal-mask" @click="toggleShippingMethodModalVisibility(false)">
          <div class="modal-wrapper">
            <div class="modal-container7" @click.stop>
              <div class="method-button-container">
                <button class="method-button" :class="{'method-button-actived':shippingMethodGlobal === 'Delivery'}"
                  style="margin-bottom: 15px;" @click="selectDeliveryMethod('Delivery')">{{ $t('delivery') }}
                </button>
              </div>
              <div class="method-button-container">
                <button class="method-button" :class="{'method-button-actived':shippingMethodGlobal === 'Pickup'}"
                  @click="selectDeliveryMethod('Pickup')">{{ $t('pickup') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition> -->

      <!-- mobile shipping method modal (afm) -->
      <!-- <transition name="modal" v-if="shippingMethodModalVisibility_mobile">
        <div class="modal-mask" @click="toggleShippingMethodModalVisibility_mobile(false)">
          <div class="modal-wrapper">
            <div class="modal-container7-d" @click.stop>
              <div class="modal-container7-d-buttonbox">
                <div class="method-button-container">
                  <button class="method-button" :class="{'method-button-actived':shippingMethodGlobal === 'Delivery'}"
                    style="margin-bottom: 15px;" @click="selectDeliveryMethod('Delivery')">{{ $t('delivery') }}
                  </button>
                </div>
                <div class="method-button-container">
                  <button class="method-button" :class="{'method-button-actived':shippingMethodGlobal === 'Pickup'}"
                    @click="selectDeliveryMethod('Pickup')">{{ $t('pick_up') }}
                  </button>
                </div>
              </div>
              <div class="radio-container-outter" v-if="shippingMethodGlobal === 'Pickup'">
                <el-radio-group class="radio-container" v-model="storeValue">
                  <div @click="selectLocation('Bellevue')">
                    <el-radio class="radio-single" :label="'Bellevue'"> Family Market Bellevue<p class="radio-small">
                      14515 NE 20th St, Bellevue, WA 98007</p>
                    </el-radio>
                  </div>
                  <el-radio :disabled="true" class="radio-single loc-disabled" :label="'Seattle'"> Family Market
                    Seattle<p class="radio-small">
                    13200 AURORA AVE N, Seattle, WA 98133</p>
                  </el-radio>
                  <el-radio :disabled="true" class="radio-single-last loc-disabled" :label="'Beaverton'"> Family
                    Market Beaverton<p class="radio-small">
                    3849 SW 117TH AVE, Beaverton, OR 97005</p>
                  </el-radio>
                </el-radio-group>
              </div>

              <div class="radio-container-outter" v-if="shippingMethodGlobal === 'Delivery'">
                <div class="zip-button-container-7"
                  :style="{background: zipcodeRequiredWarning ? '#FA6400' : '#E9C34B'}">
                  <input
                    type="text"
                    :placeholder="zipcodeRequiredWarning ? $t('enter_zipcode_star') : $t('enter_zipcode')"
                    v-model="zipcode"
                    class="landing-subscribe-field" />
                  <div class="search landing-icon-container" @click="enterZip($event,'')">
                    <img src="../assets/img/srarchs.png" alt="">
                  </div>
                </div>
              </div>
              <div class="pick-up-list" v-if="shippingMethodGlobal === 'Delivery'" >
                <div class="pick-up-list-one" v-for="(item,index) in showDeliveryList" @click="enterZip($event,item.zipcode)">
                  <div class="pick-up-list-one-img">
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                  </div>
                  <div class="pick-up-list-one-text" >
                    {{item.City}}, {{item.zipcode}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition> -->

      <!-- <transition name="modal" v-if="zipcodeModalVisibility">
        <div class="modal-mask" @click="toggleZipcodeModalVisibility(false)">
          <div class="modal-wrapper">
            <div class="modal-container8" @click.stop>
              <el-input class='el-input' v-model="modalZipcode" :placeholder="$t('enter_zipcode')"></el-input>
              <button class="zipcode-button" @click="confirmZipcode()">{{ $t('confirm') }}</button>
            </div>
          </div>
        </div>
      </transition> -->

      <!-- 微信弹窗 -->
      <!-- <transition name="modal" v-if="wxModalVisible">
        <div class="modal-mask" @click="hideWxModal">
          <div class="modal-wrapper">
            <div class="modal-container12" @click.stop>
              <img class="wx-img" src="../assets/img/wx-img.jpg" alt="">
            </div>
          </div>
        </div>
      </transition> -->

      <!-- 手机商品详情 -->
      <!-- <transition name="modal" v-if="mobileProductDetailsModalVisible">
        <div class="modal-mask" @click="hideMobileProductDetailsModal">
          <div class="modal-wrapper">
            <div class="modal-container13" @click.stop>
              <div class="close-modal" @click="hideMobileProductDetailsModal">X</div>
              <mobileProductDetails></mobileProductDetails>
            </div>
          </div>
        </div>
      </transition> -->
    </div>
  <!-- </section>
</vue-html2pdf> -->
  </div>
</template>
<script>
import Velocity from 'velocity-animate'
import html2pdf from 'html2pdf.js'
import jquery from "jquery"
import _ from 'lodash'
import { fasBars } from '@fortawesome/fontawesome-svg-core'
import Vue from 'vue';

import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from '../store/modules/cart'
import logo from '../assets/img/afm-logo.png'
import modal1 from "../view/modal"
import deliveryModal from '../../src/view/Profile/deliveryModal'
import loginNew from '../../src/view/loginNew'
import registerNew from '../../src/view/registerNew'
import guestCheckout from '../../src/view/guestCheckout'
import cartModal from '../../src/view/cartModal'
import afwSwiper from '@/components/afw-swiper/afw-swiper'
import mobileProductDetails from '@/view/mobile/mobileProductDetails'
import { locales } from "../mixin"
import { getToken } from '@/common'
import { removeWatermark, setWaterMark } from '../assets/js/watermark.js'
// import VueHtml2Canvas from 'vue-html2canvas';

var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
let $ = jquery

// Vue.use(VueHtml2Canvas);
// Vue.use(VueHtml2pdf);

const SELECT_NEW_GROUP = 'selectNewGroup'
const SELECT_NEW_CUSTOM_CATEGORY = 'selectNewCustomCategory'

export default {
  name: "navbar",
  mixins: [locales],
  components: {
    modal1,
    loginNew,
    registerNew,
    deliveryModal,
    guestCheckout,
    cartModal,
    afwSwiper,
    mobileProductDetails
  },
  props: {
    group: {
      type: String,
      default: 'munchies'
    }
  },
  data () {
    return {
      storeValue: '',
      modalZipcode: '',
      topDisabled: false,

      printShareVisibility: false,
      printShareLink: '',

      showNavBottom: false,
      items: [{
        text: 'Cut'
      },
      {
        text: 'Copy'
      },
      {
        text: 'Paste'
      }
      ],
      hoverIndex: '',
      hoverName: '',
      phoneNav: false, // mobile group dropdown
      bouns: false, //上下滑动 添加class
      scroll: 0, //上下滑动距离
      MunchiesShow: false, //一级导航显示
      search: false, //搜索框展示
      productName: '', //搜索绑定的值
      device: '',
      zipcode: '',
      cartX: null,
      cartY: null,
      delta: null,
      local: null,
      checkoutModal: false,
      showAccountPortal: false,
      userIconCoordinate: {
        left: 0,
        top: 0,
      },
      searchTerm: '',
      isMobile: isMobile,
      groupTab: false,
      activeGroup: '',
      categoriesTab: false,
      categories: [],
      activeCategory: '',
      groupOptions: [],
      dropDownSelection: {},

      loginModalVisibilityLocal: false,
      registerModalVisibilityLocal: false,
      accountImages: {
        default: require('@/assets/img/navbarAccount.svg'),
        hover: require("@/assets/img/navbarAccountHover.svg")
      },
      favoriteImages: {
        default: require('@/assets/img/navbarHeart.svg'),
        hover: require("@/assets/img/navbarHeartHover.svg")
      },
      accountImage: require('@/assets/img/navbarAccount.svg'),
      favoriteImage: require('@/assets/img/navbarHeart.svg'),
      zipcodeRequiredWarning: false,
      //公司的相关数据
      companyAll: [],
      company_id: undefined,
      warehouseAll: [],
      warehouse_id: undefined,
      company_disabled: false,
      groupVal: {},
      printDisabled: true,
    }
  },
  methods: {
    copy() {
      this.$notify({
        type: 'success',
        title: 'Code Copied',
        // message: '分享链接给好友',
        position: 'bottom-right',
        duration: 2000
      });
    },
    // generatePdf(){
    //   const el = this.$refs.testHtml;
    //   // add option type to get the image version
    //   // if not provided the promise will return
    //   // the canvas.
    //   const options = {
    //     type: 'dataURL'
    //   }
    // },
    ...mapActions('navbar', ['fetchGroups', 'getDeliveryCodeList', 'uploadShare']),
    ...mapActions('auth', ['fetchCustomerInformation']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapActions('products', ['fetchCategories', 'getCompany', 'getWarehouseByCompany', 'changeCompanyId', 'changeWarehouseId']),
    ...mapActions('orders', ['fetchOrderByTimeFrame', 'fetchOrderDetails']),
    ...mapMutations('auth', ['logout', 'updateLoginStatus']),
    ...mapMutations('cart', ['resetAddToCartSuccess', 'closeCart', 'openCart', 'toggleCartModal']),
    ...mapMutations('navbar', ['updateShippingMethodGlobal', 'toggleZipcodeModalVisibility',
      'resetHomeWithinRadius', 'updateSearchTerm', 'handleWindowResize', 'updateDevice', 'toggleModal',
      'handleNavToAccountFromNavbar', 'mobileDevice', 'toggleLoginModalVisibility', 'toggleRegisterModalVisibility',
      'toggleProductDetailImgVisibility', 'toggleWarehouseSelectionModalVisibility', 'toggleGuestCheckoutVisiblity',
      'toggleShippingMethodModalVisibility', 'hideWxModal', 'toggleShippingMethodModalVisibility_mobile',
      'hideMobileProductDetailsModal'
    ]),
    ...mapMutations('products', ['updateActiveProduct', 'updateActiveQuantity']),
    ...mapMutations('orders', ['toggleOrderModal', 'setOrderId']),
    ...mapActions(['changeShowProductsType1', 'changeShowProductsType2', 'changeShowProductsType3', 'changeShowList']),
    generateTotalItems() {
      return this.cartProductsList.TotalCount;
    },
    handleWindowChange () {
      this.handleWindowResize({
        windowWidth: document.documentElement.clientWidth,
        windowHeight: document.documentElement.clientHeight,
      })
    },
    handleProductsMouseLeave (e) {
      const classNameArray = ['cascade']
      if (classNameArray.includes(e.relatedTarget.className.split(' ')[0])) {
        return
      } else {
        this.groupTab = false
      }
    },
    handleCartMouseEnter (e) {
      this.toggleCartModal(true)
    },
    handleCartMouseOut (e) {
      const classNameArray = ['content', 'empty_cart', 'icon-container']
      if (e.relatedTarget) {
        if (classNameArray.includes(e.relatedTarget.className.split(' ')[0])) {
          return
        } else {
          this.toggleCartModal(false)
        }
      }
    },
    handleGroupTab () {
      this.groupTab = !this.groupTab
    },
    navigateHeader (val) {
      //保存显示产品的类型
      this.changeShowProductsType1('categories')
      this.changeShowProductsType2(null)
      this.changeShowProductsType3(null)
      //保存用户选择的分类
      this.groupVal = val
      this.groupTab = false
      this.removeCollectionsSelectItem()
      if (val.group) {
        this.navGo(val.value)
      } else {
        this.goToCategory2(val)
      }
    },
    enterZip (e, selectCode) {
      e.preventDefault()
      if (selectCode) {
        this.zipcode = selectCode
      }
      if (!this.zipcode) {
        this.zipcodeRequiredWarning = true
        return
      }
      // this.updateShippingMethodGlobal('Delivery');
      // this.$store.dispatch('navbar/validateDeliveryRadius', this.zipcode);
      this.resetHomeWithinRadius()
      this.toggleShippingMethodModalVisibility(false)
      this.toggleShippingMethodModalVisibility_mobile(false)
    },
    goToCategory2 (item) {
      let category = {}
      this.allGroups.find(group => {
        return group.Categories.find(cat => {
          if (item.value !== cat.ProductCategory_id) {
            return false
          }
          category = {
            ...item,
            ...cat
          }
          return true
        })
      })
      if (this.$router.currentRoute.path !== '/collections') {
        this.$router.push(`/collections`)
        setTimeout(() => {
          this.$root.selectNewCategory(category)
        }, 600)
      } else {
        this.$root.selectNewCategory(category)
      }
    },
    handleActiveGroup (group) {
      this.activeGroup = group.Name
      this.categories = group.Categories
    },
    handleActiveCategory (category) {
      this.activeCategory = category.Name
    },
    navToAccount (target) {
      this.handleNavToAccountFromNavbar(target)
      if (this.$route.name !== 'account') {
        this.$router.push('/account')
      }
    },
    changeCoordinateOfModal () {
      if (document.getElementsByClassName('navusername')[0]) {
        this.userIconCoordinate = {
          left: document.getElementsByClassName('navusername')[0].getBoundingClientRect().x - 130 + 'px',
          top: document.getElementsByClassName('navusername')[0].getBoundingClientRect().y + 29 + 'px',
        }
      }
    },
    cartDetailsModalChange () {
      this.cartX = document.getElementsByClassName('site-header__cart-count')[0].getBoundingClientRect().x + 'px'
      this.cartY = document.getElementsByClassName('site-header__cart-count')[0].getBoundingClientRect().y + 'px'
    },
    bounsShow () {
      // if (this.bouns) {
      //   document.getElementsByTagName("body")[0].className = "body_top";
      // } else {
      //   document.getElementsByTagName("body")[0].className = "";
      // }
    },
    handleScroll () {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
      if (this.scroll > 0) {
        this.bouns = true
        this.bounsShow()
      } else {
        this.bouns = false
        this.bounsShow()
      }
    },
    //路由跳转 1 登录 2购物车
    active (num) {
      if (num == 1) {
        // this.$router.push("/login");
      } else if (num == 2) {
        this.$router.push("/cart")
      } else if (num == 3) {
        this.$router.push("/purchase")
      }
    },
    //rediract screen
    mobileNavGo (id) {
      this.phoneNav = false
      this.navGo(id)
    },
    navGo (id) {
      let group = []
      //类型数据中有数组
      if (Array.isArray(id)) {
        id.forEach(item => {
          this.allGroups.forEach(item2 => {
            if (item === item2.ProductGroup_id) {
              group.push(item2)
            }
          })
        })
      } else {
        group = this.allGroups.filter(group => group.ProductGroup_id === id)[0]
      }
      if (this.$router.currentRoute.path !== '/collections') {
        this.$router.push(`/collections`)
        setTimeout(() => {
          this.$root.selectNewGroup(group, 'nav')
        }, 600)
      } else {
        this.$root.selectNewGroup(group, 'nav')
      }
    },
    // hover on group image
    change (name, index) {
      this.hoverIndex = index
      this.hoverName = name
    },
    phoneNavShow () {
      this.phoneNav = !this.phoneNav
    },
    //搜索展示
    searchShow () {
      this.search = !this.search
    },
    //Sign out User
    signOut () {
      this.logout()
    },
    tokenIsValid () {
      //send token to server see if it is still valid
      return true
    },
    searchProduct () {
      //保存显示产品的类型
      this.changeShowProductsType1(null)
      this.changeShowProductsType2('search')
      this.changeShowProductsType3(null)
      // this.$router.push({ path: '/search', query: { product: this.searchTerm}})
      // this.search = false;
      if (this.$router.currentRoute.path !== '/collections') {
        this.removeCollectionsSelectItem()
        this.$router.push(`/collections`)
        setTimeout(() => {
          this.$root.selectNewSearch(this.searchTerm, 'Name')
        }, 600)
      } else {
        this.$root.selectNewSearch(this.searchTerm, 'Name')
      }
    },
    // validateDeliveryRadius(event) {
    //   const inputValue = event.target.value;
    //   if ((!Number.isNaN(Number(inputValue))) || inputValue === '') {
    //     this.zipcode = inputValue;
    //   }
    // },
    getPos (el) {
      for (var lx = 0, ly = 0; el != null; lx += el.offsetLeft, ly += el.offsetTop, el = el.offsetParent);
      this.cartX = lx
      this.cartY = ly
    },
    calculateLocalSubtotal () {
      if (this.local) {
        let cost = 0
        this.$store.state.cart.cartProductsList.map(item => {
          let itemPrice = item.Price * item.quantity
          cost += itemPrice
        })
        return cost.toFixed(2)
      }
      return this.$store.state.cart.cartProductsList.TotalPrice.toFixed(2)
    },
    goToProductDetail (product) {
      this.updateActiveProduct(product.ProductNum)
      this.$router.push({
        name: 'productDetails',
        query: {
          productNum: product.ProductNum
        }
      })
    },
    goToLanding () {
      if (this.$route.name !== 'LandingPage') {
        this.$router.push('/')
        setTimeout(() => {
          this.$root.resetPage()
        }, 1000)
      }
      // this.toggleModal(true);
    },
    goToHome () {
      if (this.$route.name !== 'Home') {
        this.routerToHome()
        setTimeout(() => {
          const resetPage = this.$root.resetPage
          resetPage && resetPage()
        }, 1000)
      }
      // this.toggleModal(true);
    },
    setLocation () {
      this.toggleWarehouseSelectionModalVisibility(true)
    },
    goToAccount (param) {
      if (isUserAuthenticated()) {
        if (param) {
          if (this.$router.currentRoute.path === '/account') {
            this.handleNavToAccountFromNavbar(param)
          } else {
            this.$router.push({
              name: 'account',
              params: {
                component: param
              }
            })
          }
        } else {
          this.$router.push('/account')
        }
      } else {
        this.toggleLoginModalVisibility(true)
      }
    },
    toggleImgModalVisibility (status, img) {
      this.toggleProductDetailImgVisibility({
        status,
        img
      })
    },
    togglePrintShareVisibility(status, link) {
      this.printShareVisibility = status;
      this.printShareLink = link;
    },
    selectLocation (location) {
      this.company_id = location
      const goToHome = localStorage.getItem('goToHome')
      if (location === localStorage.getItem('warehouseLocationWeb')) {
        this.toggleModal(false)
        this.toggleWarehouseSelectionModalFalse()
        this.toggleShippingMethodModalVisibility(false)
        this.toggleShippingMethodModalVisibility_mobile(false)
        location && goToHome && this.routerToHome()
        return
      }
      // const obj = {
      //   'Seattle': '98133',
      //   'Bellevue': '98007',
      //   'Beaverton': '97005',
      // }
      // const val = obj[location]
      // val && this.$store.dispatch('navbar/validateDeliveryRadius', val);
      this.resetHomeWithinRadius()
      this.toggleModal(false)
      this.toggleWarehouseSelectionModalFalse()
      this.toggleShippingMethodModalVisibility(false)
      this.toggleShippingMethodModalVisibility_mobile(false)
      val && goToHome && this.routerToHome()
    },
    toggleCart () {
      this.toggleCartModal(!this.cartModalVisible)
    },
    selectDeliveryMethod (method) {
      this.updateShippingMethodGlobal(method)
      this.toggleShippingMethodModalVisibility(false)
    },
    // confirmZipcode() {
    //   this.toggleZipcodeModalVisibility(false);
    //   if (this.modalZipcode) {
    //     this.$store.dispatch('navbar/validateDeliveryRadius', this.modalZipcode);
    //     this.resetHomeWithinRadius();
    //   }
    // },
    // copying the add to cart process from the product card because guest checkout breaks without it for some reason
    handleAddToCartSuccess (payload) {
      this.$store.dispatch('cart/addCart', payload.item)
        .then(() => {
          this.$store.dispatch('cart/getCart')
        })
    },
    handleAddToCartFail (product) {
      this.stopAddToCartLoading()
      if (localStorage.Lang === 'ch') {
        alert(this.$t('stock_msg_1') + `${product.Name}` + this.$t('stock_msg_2'))
      } else {
        alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`)
      }
    },
    throttleAddToCart: _.debounce(function (item, event) {
      this.addToCart(item)
    }, 150, {
      'leading': true,
      'trailing': true
    }),
    addToCart: function (item) {
      if (!localStorage.getItem('warehouseLocationWeb')) {
        this.toggleWarehouseSelectionModalVisibility(true)
        return
      }
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({
            success: this.handleAddToCartSuccess,
            fail: this.handleAddToCartFail,
            item,
            event: event
          })
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    // 移除collection路由中需要的缓存的已选择的item
    removeCollectionsSelectItem () {
      localStorage.removeItem(SELECT_NEW_GROUP)
      localStorage.removeItem(SELECT_NEW_CUSTOM_CATEGORY)
    },
    toggleWarehouseSelectionModalFalse () {
      this.toggleWarehouseSelectionModalVisibility(false)
      localStorage.removeItem('goToHome')
    },
    routerToHome () {
      this.$router.push('/home')
    },
    //点击打印
    async clickPrint () {
      const productListIsLoading = this.$root.getProductListIsLoading()
      if (productListIsLoading) {
        return this.$confirm(this.$t('data_loading_tip'), this.$t('tips_text'), {
          confirmButtonText: this.$t('confirm_text'),
          cancelButtonText: this.$t('cancel_text'),
          showCancelButton: false,
          showConfirmButton: false,
          type: 'error'
        }).then(() => true).catch(() => false)
      }
      await new Promise(resolve => this.$nextTick(resolve))
      const isLoadAll = this.$root.getProductCardImgIsLoad()
      // if (!isLoadAll) {
      //   const isConfirm = await this.$confirm(this.$t('img_loading_tips_text'), this.$t('tips_text'), {
      //     confirmButtonText: this.$t('confirm_text'),
      //     cancelButtonText: this.$t('cancel_text'),
      //     type: 'warning'
      //   }).then(() => true).catch(() => false)
      //   // 如果点击的取消
      //   if (!isConfirm) return
      // }
      //没有产品时禁止打印
      if (this.showList && this.showList.length > 0) {
        this.printDisabled = false
      } else {
        this.$confirm(this.$t('you_can_at_print_without_a_product'), this.$t('tips_text'), {
          confirmButtonText: this.$t('confirm_text'),
          cancelButtonText: this.$t('cancel_text'),
          showCancelButton: false,
          showConfirmButton: false,
          type: 'error'
        }).then(() => true).catch(() => false)
        return this.printDisabled = true
      }
      await new Promise(resolve => setTimeout(resolve, 1000))
      // var productPrintLs = document.getElementById('prodicts_print_ls');
      //先隐藏
      document.getElementById('navbar').style.display = 'none'
      document.getElementById('banner').style.display = 'none'
      document.getElementById('category-buttons').style.display = 'none'
      document.getElementById('products_div').style.display = 'none'
      document.getElementById('munFooter').style.display = 'none'
      document.getElementById('pcRecommended').style.display = 'none'
      document.getElementById('category-filter').style.display = 'none'
      var stockRows = document.querySelectorAll('.stock_row_dv') // stock row
      var priceRows = document.querySelectorAll('.price_row_dv') // price row
      var priceHides = document.querySelectorAll('.price_hide_show') // price show or hide
      var stocks = document.querySelectorAll('.stock_sp')
      var stockReds = document.querySelectorAll('.stock_sp_red')
      var stockGreens = document.querySelectorAll('.stock_sp_green')
      var prices = document.querySelectorAll('.price_sp')
      var ltTitles = document.querySelectorAll('.title_lt_p')
      var rgTitles = document.querySelectorAll('.title_lt_p')
      var ltRefnos = document.querySelectorAll('.refNo_sp')
      var rgRefnos = document.querySelectorAll('.refNo_rg_sp')

      if (this.selectPrint) {
        var selectPrintRef = document.querySelectorAll('.no-print')
        for (let i=0;i<selectPrintRef.length;i++) {
          selectPrintRef[i].classList.remove('no-print');
          selectPrintRef[i].classList.add('none-print');
        }
        var selectBoxRef = document.querySelectorAll('.product_box2')
        for (let i=0;i<selectBoxRef.length;i++) {
          selectBoxRef[i].classList.remove('product_box2');
          selectBoxRef[i].classList.add('product_box');
        }
      }

      var addIconRef = document.querySelectorAll('.qty_and_cart')
      for (let i=0;i<addIconRef.length;i++) {
        // addIconRef[i].classList.remove('qty_and_cart');
        addIconRef[i].classList.add('none-print');
      }

      var productListingRef = document.querySelectorAll('.product-listing-container')
      for (let i=0;i<productListingRef.length;i++) {
        // productListingRef[i].classList.remove('product-listing-container');
        productListingRef[i].classList.add('product-listing-container-print');
      }

      var productCardRef = document.querySelectorAll('.product-card')
      for (let i=0;i<productCardRef.length;i++) {
        productCardRef[i].classList.add('product-card-print');
      }

      for (let i=0;i<stockRows.length;i++) {
        stockRows[i].classList.remove('pro_cl_lf');
        stockRows[i].classList.add('pro_cl_lf_print');
      }
      for (let i=0;i<priceRows.length;i++) {
        priceRows[i].classList.remove('pro_cl_rg');
        priceRows[i].classList.add('pro_cl_rg_print');
      }
      for (let i=0;i<priceHides.length;i++) {
        priceHides[i].classList.remove('price_hide');
        priceHides[i].classList.add('price_show_print');
      }
      for (let i=0;i<stocks.length;i++) {
        stocks[i].classList.remove('pro_tt');
        stocks[i].classList.add('pro_t_print');
      }
      for (let i=0;i<stockReds.length;i++) {
        stockReds[i].classList.remove('pro_tt_red');
        stockReds[i].classList.add('pro_tt_red_print');
      }
      for (let i=0;i<stockGreens.length;i++) {
        stockGreens[i].classList.remove('pro_tt_green');
        stockGreens[i].classList.add('pro_tt_green_print');
      }
      for (let i=0;i<prices.length;i++) {
        prices[i].classList.remove('pro_tt');
        prices[i].classList.add('pro_t_print');
      }
      for (let i=0;i<ltTitles.length;i++) {
        ltTitles[i].classList.remove('ProTitle');
        ltTitles[i].classList.add('ProTitle_print');
      }
      for (let i=0;i<rgTitles.length;i++) {
        rgTitles[i].classList.remove('ProTitle_r');
        rgTitles[i].classList.add('towLineTx');
      }

      for (let i=0;i<ltRefnos.length;i++) {
        ltRefnos[i].classList.remove('pro_tt');
        ltRefnos[i].classList.add('pro_tt_left_print');
      }
      for (let i=0;i<rgRefnos.length;i++) {
        rgRefnos[i].classList.remove('pro_t_one');
        rgRefnos[i].classList.add('pro_tt_right_print');
      }

      const moreBtn = document.getElementById('product-show-more-button')
      if (moreBtn) {
        moreBtn.style.display = 'none'
      }
      //判断是否登录
      if (this.userInfo.FirstName || this.userInfo.LastName) {
        //添加水印
        setWaterMark('', this.userInfo.FirstName + this.userInfo.LastName)
      }
      setTimeout(()=> {
        //调用打印
        window.print()
          
        //再显示
        document.getElementById('navbar').style.display = 'block'
        document.getElementById('banner').style.display = 'block'
        document.getElementById('category-buttons').style.display = 'block'
        document.getElementById('products_div').style.display = 'flex'
        document.getElementById('munFooter').style.display = 'block'
        document.getElementById('pcRecommended').style.display = 'block'
        document.getElementById('category-filter').style.display = 'block'

        if (this.selectPrint) {
          for (let i=0;i<selectPrintRef.length;i++) {
            selectPrintRef[i].classList.remove('none-print');
            selectPrintRef[i].classList.add('no-print');
          }
          for (let i=0;i<selectBoxRef.length;i++) {
            selectBoxRef[i].classList.remove('product_box');
            selectBoxRef[i].classList.add('product_box2');
          }
        }
        for (let i=0;i<addIconRef.length;i++) {
          // addIconRef[i].classList.remove('qty_and_cart');
          addIconRef[i].classList.remove('none-print');
        }
        
        for (let i=0;i<productListingRef.length;i++) {
          productListingRef[i].classList.remove('product-listing-container-print');
        }
        for (let i=0;i<productCardRef.length;i++) {
          productCardRef[i].classList.remove('product-card-print');
        }
        for (let i=0;i<stockRows.length;i++) {
          stockRows[i].classList.remove('pro_cl_lf_print');
          stockRows[i].classList.add('pro_cl_lf');
        }
        for (let i=0;i<priceRows.length;i++) {
          priceRows[i].classList.remove('pro_cl_rg_print');
          priceRows[i].classList.add('pro_cl_rg');
        }
        for (let i=0;i<priceHides.length;i++) {
          priceHides[i].classList.remove('price_show_print');
          priceHides[i].classList.add('price_hide');
        }
        for (let i=0;i<stocks.length;i++) {
          stocks[i].classList.remove('pro_t_print');
          stocks[i].classList.add('pro_tt');
        }
        for (let i=0;i<stockReds.length;i++) {
          stockReds[i].classList.remove('pro_tt_red_print');
          stockReds[i].classList.add('pro_tt_red');
        }
        for (let i=0;i<stockGreens.length;i++) {
          stockGreens[i].classList.remove('pro_tt_green_print');
          stockGreens[i].classList.add('pro_tt_green');
        }
        for (let i=0;i<prices.length;i++) {
          prices[i].classList.remove('pro_t_print');
          prices[i].classList.add('pro_tt');
        }
        for (let i=0;i<ltTitles.length;i++) {
          ltTitles[i].classList.remove('ProTitle_print');
          ltTitles[i].classList.add('ProTitle');
        }
        for (let i=0;i<rgTitles.length;i++) {
          rgTitles[i].classList.remove('towLineTx');
          rgTitles[i].classList.add('ProTitle_r');
        }

        for (let i=0;i<ltRefnos.length;i++) {
          ltRefnos[i].classList.remove('pro_tt_left_print');
          ltRefnos[i].classList.add('pro_tt');
        }
        for (let i=0;i<rgRefnos.length;i++) {
          rgRefnos[i].classList.remove('pro_tt_right_print');
          rgRefnos[i].classList.add('pro_t_one');
        }
        if (moreBtn) {
          moreBtn.style.display = 'block'
        }
        if (this.userInfo.FirstName || this.userInfo.LastName) {
          //删除水印
          removeWatermark()
        }
      }, 1000)
    },

    async clickShare() {
      const productListIsLoading = this.$root.getProductListIsLoading()
      if (productListIsLoading) {
        return this.$confirm(this.$t('data_loading_tip'), this.$t('tips_text'), {
          confirmButtonText: this.$t('confirm_text'),
          cancelButtonText: this.$t('cancel_text'),
          showCancelButton: false,
          showConfirmButton: false,
          type: 'error'
        }).then(() => true).catch(() => false)
      }
      await new Promise(resolve => this.$nextTick(resolve))
      const isLoadAll = this.$root.getProductCardImgIsLoad()
      // if (!isLoadAll) {
      //   const isConfirm = await this.$confirm(this.$t('img_loading_tips_text'), this.$t('tips_text'), {
      //     confirmButtonText: this.$t('confirm_text'),
      //     cancelButtonText: this.$t('cancel_text'),
      //     type: 'warning'
      //   }).then(() => true).catch(() => false)
      //   // 如果点击的取消
      //   if (!isConfirm) return
      // }
      //没有产品时禁止打印
      if (this.showList && this.showList.length > 0) {
        this.printDisabled = false
      } else {
        this.$confirm(this.$t('you_can_at_print_without_a_product'), this.$t('tips_text'), {
          confirmButtonText: this.$t('confirm_text'),
          cancelButtonText: this.$t('cancel_text'),
          showCancelButton: false,
          showConfirmButton: false,
          type: 'error'
        }).then(() => true).catch(() => false)
        return this.printDisabled = true
      }
      await new Promise(resolve => setTimeout(resolve, 1000))
      // var productPrintLs = document.getElementById('prodicts_print_ls');
      //先隐藏
      document.getElementById('navbar').style.display = 'none'
      document.getElementById('banner').style.display = 'none'
      document.getElementById('category-buttons').style.display = 'none'
      document.getElementById('products_div').style.display = 'none'
      document.getElementById('munFooter').style.display = 'none'
      document.getElementById('pcRecommended').style.display = 'none'
      document.getElementById('category-filter').style.display = 'none'
      var stockRows = document.querySelectorAll('.stock_row_dv') // stock row
      var priceRows = document.querySelectorAll('.price_row_dv') // price row
      var priceHides = document.querySelectorAll('.price_hide_show') // price show or hide
      var stocks = document.querySelectorAll('.stock_sp')
      var stockReds = document.querySelectorAll('.stock_sp_red')
      var stockGreens = document.querySelectorAll('.stock_sp_green')
      var prices = document.querySelectorAll('.price_sp')
      var ltTitles = document.querySelectorAll('.title_lt_p')
      var rgTitles = document.querySelectorAll('.title_lt_p')
      var ltRefnos = document.querySelectorAll('.refNo_sp')
      var rgRefnos = document.querySelectorAll('.refNo_rg_sp')

      if (this.selectPrint) {
        var selectPrintRef = document.querySelectorAll('.no-print')
        for (let i = 0; i < selectPrintRef.length; i++) {
          selectPrintRef[i].classList.remove('no-print');
          selectPrintRef[i].classList.add('none-print');
        }
        var selectBoxRef = document.querySelectorAll('.product_box2')
        for (let i = 0; i < selectBoxRef.length; i++) {
          selectBoxRef[i].classList.remove('product_box2');
          selectBoxRef[i].classList.add('product_box');
        }
      }

      var imgRef = document.querySelectorAll('.nonprint-img')
      for (let i = 0; i < imgRef.length; i++) {
        imgRef[i].classList.remove('nonprint-img'); // this is not remove
        imgRef[i].classList.add('print-img');
      }

      var productListingRef = document.querySelectorAll('.product-listing-container')
      for (let i = 0; i < productListingRef.length; i++) {
        // productListingRef[i].classList.remove('product-listing-container');
        productListingRef[i].classList.add('product-listing-container-print');
      }

      var productCardRef = document.querySelectorAll('.product-card')
      for (let i = 0; i < productCardRef.length; i++) {
        productCardRef[i].classList.add('product-card-print');
      }

      for (let i = 0; i < stockRows.length; i++) {
        stockRows[i].classList.remove('pro_cl_lf');
        stockRows[i].classList.add('pro_cl_lf_print');
      }
      for (let i = 0; i < priceRows.length; i++) {
        priceRows[i].classList.remove('pro_cl_rg');
        priceRows[i].classList.add('pro_cl_rg_print');
      }
      for (let i = 0; i < priceHides.length; i++) {
        priceHides[i].classList.remove('price_hide');
        priceHides[i].classList.add('price_show_print');
      }
      for (let i = 0; i < stocks.length; i++) {
        stocks[i].classList.remove('pro_tt');
        stocks[i].classList.add('pro_t_print');
      }
      for (let i = 0; i < stockReds.length; i++) {
        stockReds[i].classList.remove('pro_tt_red');
        stockReds[i].classList.add('pro_tt_red_print');
      }
      for (let i = 0; i < stockGreens.length; i++) {
        stockGreens[i].classList.remove('pro_tt_green');
        stockGreens[i].classList.add('pro_tt_green_print');
      }
      for (let i = 0; i < prices.length; i++) {
        prices[i].classList.remove('pro_tt');
        prices[i].classList.add('pro_t_print');
      }
      for (let i = 0; i < ltTitles.length; i++) {
        ltTitles[i].classList.remove('ProTitle');
        ltTitles[i].classList.add('ProTitle_print');
      }
      for (let i = 0; i < rgTitles.length; i++) {
        rgTitles[i].classList.remove('ProTitle_r');
        rgTitles[i].classList.add('towLineTx');
      }

      for (let i = 0; i < ltRefnos.length; i++) {
        ltRefnos[i].classList.remove('pro_tt');
        ltRefnos[i].classList.add('pro_tt_left_print');
      }
      for (let i = 0; i < rgRefnos.length; i++) {
        rgRefnos[i].classList.remove('pro_t_one');
        rgRefnos[i].classList.add('pro_tt_right_print');
      }

      const moreBtn = document.getElementById('product-show-more-button')
      if (moreBtn) {
        moreBtn.style.display = 'none'
      }
      //判断是否登录
      if (this.userInfo.FirstName || this.userInfo.LastName) {
        //添加水印
        setWaterMark('', this.userInfo.FirstName + this.userInfo.LastName)
      }

      html2pdf().set({
        margin: [0.4, 0, 0.4, 0],
        // image: {
        //   type: 'png',
        //    quality: 0.95
        // },
        html2canvas: {
          scale: 2,
          // imageTimeout: 0,
          allowTaint: true, 
          useCORS: true,
          // foreignObjectRendering: true 
        },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      })
        .from(document.getElementById('product-list-container-id'))
        .output('blob')
        // .save();
        .then(blob => {
          const formData = new FormData();
          formData.append('files', blob);
          //todo call upload api
          // this.uploadShare(formData);
          this.uploadShare(formData).then(res => {
            if (res && res.data && res.data[0]) {
              this.togglePrintShareVisibility(true, res.data[0]);
            }
            setTimeout(() => {
              //调用打印
              // window.print()
              //再显示
              document.getElementById('navbar').style.display = 'block'
              document.getElementById('banner').style.display = 'block'
              document.getElementById('category-buttons').style.display = 'block'
              document.getElementById('products_div').style.display = 'flex'
              document.getElementById('munFooter').style.display = 'block'
              document.getElementById('pcRecommended').style.display = 'block'
              document.getElementById('category-filter').style.display = 'block'

              if (this.selectPrint) {
                for (let i = 0; i < selectPrintRef.length; i++) {
                  selectPrintRef[i].classList.remove('none-print');
                  selectPrintRef[i].classList.add('no-print');
                }
                for (let i = 0; i < selectBoxRef.length; i++) {
                  selectBoxRef[i].classList.remove('product_box');
                  selectBoxRef[i].classList.add('product_box2');
                }
              }
              for (let i = 0; i < productListingRef.length; i++) {
                productListingRef[i].classList.remove('product-listing-container-print');
              }
              for (let i = 0; i < productCardRef.length; i++) {
                productCardRef[i].classList.remove('product-card-print');
              }
              for (let i = 0; i < stockRows.length; i++) {
                stockRows[i].classList.remove('pro_cl_lf_print');
                stockRows[i].classList.add('pro_cl_lf');
              }
              for (let i = 0; i < priceRows.length; i++) {
                priceRows[i].classList.remove('pro_cl_rg_print');
                priceRows[i].classList.add('pro_cl_rg');
              }
              for (let i = 0; i < priceHides.length; i++) {
                priceHides[i].classList.remove('price_show_print');
                priceHides[i].classList.add('price_hide');
              }
              for (let i = 0; i < stocks.length; i++) {
                stocks[i].classList.remove('pro_t_print');
                stocks[i].classList.add('pro_tt');
              }
              for (let i = 0; i < stockReds.length; i++) {
                stockReds[i].classList.remove('pro_tt_red_print');
                stockReds[i].classList.add('pro_tt_red');
              }
              for (let i = 0; i < stockGreens.length; i++) {
                stockGreens[i].classList.remove('pro_tt_green_print');
                stockGreens[i].classList.add('pro_tt_green');
              }
              for (let i = 0; i < prices.length; i++) {
                prices[i].classList.remove('pro_t_print');
                prices[i].classList.add('pro_tt');
              }
              for (let i = 0; i < ltTitles.length; i++) {
                ltTitles[i].classList.remove('ProTitle_print');
                ltTitles[i].classList.add('ProTitle');
              }
              for (let i = 0; i < rgTitles.length; i++) {
                rgTitles[i].classList.remove('towLineTx');
                rgTitles[i].classList.add('ProTitle_r');
              }
              for (let i = 0; i < ltRefnos.length; i++) {
                ltRefnos[i].classList.remove('pro_tt_left_print');
                ltRefnos[i].classList.add('pro_tt');
              }
              for (let i = 0; i < rgRefnos.length; i++) {
                rgRefnos[i].classList.remove('pro_tt_right_print');
                rgRefnos[i].classList.add('pro_t_one');
              }
              if (moreBtn) {
                moreBtn.style.display = 'block'
              }
              if (this.userInfo.FirstName || this.userInfo.LastName) {
                //删除水印
                removeWatermark()
              }
            }, 1000);
          }).catch(err => {
            console.log('error sharing file ', err)
          });
        });
    },

    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      })
    },

    //更改公司重新查询
    async changeCompany () {
      if (this.showProductsType1 == 'categories') {
        //navbar选择分组或分类
        return this.navigateHeader(this.groupVal)
      }
      if (this.showProductsType2 == 'search') {
        //navbar搜索
        return this.searchProduct()
      }
      if (this.showProductsType3 == 'group') {
        //productList选择分组
        return this.$root.selectNewGroup(this.navGoId)
      }
      if (this.$route.name === 'Home') {
        //设置仓库id
        let data = {
          company_id: 0,
          warehouse_id: 0
        }
        if (this.company_id === 1) {
          data.company_id = 1
          data.warehouse_id = 1
        }
        if (this.company_id === 2) {
          data.company_id = 2
          data.warehouse_id = 2
        }
        if (this.company_id === 3) {
          data.company_id = 3
          data.warehouse_id = 8
        }
        if (this.company_id === 4) {
          data.company_id = 4
          data.warehouse_id = 9
        }
        if (this.company_id === 5) {
          data.company_id = 5
          data.warehouse_id = 10
        }
        //公司切换时随着变动
        return await this.$store.dispatch('products/fetchCustomCategories', data)
      }
      //跳转页面
      this.$router.push('/home')
    },
    //跳转至Contact Us
    async clickContactUs(){
      this.$router.push('/contact-us')
    }
  },
  beforeMount () {
    if (isUserAuthenticated()) {
      this.local = false
      this.$store.dispatch('cart/getCart')
    } else {
      this.local = true
      this.$store.dispatch('cart/fetchCartProducts')
    }
    if (window.screen.width < 900) {
      //WAP and ONLINE are what Yuansfer uses to distinguish between mobile
      //and desktop devices.
      this.updateDevice('WAP')
    } else {
      this.updateDevice('ONLINE')
    }
    if (window.screen.width <= 500) {
      this.mobileDevice(true)
    } else {
      this.mobileDevice(false)
    }
  },
  mounted () {
    let cart = document.getElementsByClassName('site-header__cart-count')[0]
    if (getToken() && this.tokenIsValid(getToken())) {
      this.updateLoginStatus(true)
    };
    window.addEventListener('scroll', this.handleScroll, true)
    this.fetchGroups()
    this.getDeliveryCodeList()
    // if (this.$router.history.current.name !== 'purchase' && !localStorage.getItem('warehouseLocationWeb')) {
    //   this.toggleModal(true);
    // }
    this.$store.dispatch('auth/fetchCustomerInformation')
    this.getPos(cart)
    this.$store.dispatch('orders/fetchOrderByTimeFrame', 3)
    this.$nextTick(function () {

      this.changeCoordinateOfModal()
      this.handleWindowChange()
    })
    if (localStorage.Lang != null) this.$i18n.locale = localStorage.Lang
    if (this.$router.currentRoute.path === '/') {
      this.showNavBottom = false
    } else {
      this.showNavBottom = true
    }
    if (!localStorage.getItem('shippingMethodGlobal')) {
      this.updateShippingMethodGlobal('Delivery')
    }
  },
  created () {
    window.addEventListener('resize', this.changeCoordinateOfModal)
    window.addEventListener('resize', this.handleWindowChange)
    this.handleWindowChange()
    this.$root.navbarSelectLocation = this.selectLocation
    //默认赋值
    this.company_id = this.companyId
    //获取所有的公司信息
    this.getCompany()
      .then(res => {
        const data = res.data.map(obj => {
          if (obj.id === 1) {
            return { ...obj, guestName: '加州公司' }
          }
          if (obj.id === 2) {
            return { ...obj, guestName: '新泽西公司' }
          }
          if (obj.id === 3) {
            return { ...obj, guestName: '丽尔薇集团(美妆)' }
          }
          if (obj.id === 4) {
            return { ...obj, guestName: '芝加哥公司' }
          }
          if (obj.id === 5) {
            return { ...obj, guestName: '德州公司' }
          }
          return obj
        })

        this.companyAll = data
        // reset to first one if no value
        if (!this.company_id) {
          this.company_id = this.companyAll[0].id
        }
      }).catch(err => {
        console.log('err brand', err)
      })
  },
  destroyed () {
    window.removeEventListener("resize", this.changeCoordinateOfModal)
    window.removeEventListener('resize', this.handleWindowChange)
  },
  computed: {
    ...mapState({
      loggedIn: state => state.auth.loggedIn,
      cart: state => state.cart.itemCount,
      allGroups: state => state.navbar.allGroups,
      cartProducts: state => state.cart.cartProductsList,
      homeWithinRadius: state => state.navbar.homeWithinRadius,
      homeRadiusChecked: state => state.navbar.homeRadiusChecked,
      checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
      checkoutRadiusChecked: state => state.navbar.checkoutRadiusChecked,
      showModal: state => state.navbar.showModal,
      warehouseLocation: state => state.navbar.warehouseLocation,
      addToCartLoading: state => state.cart.addToCartLoading,
      addToCartSuccessful: state => state.cart.addToCartSuccessful,
      itemAdded: state => state.cart.itemAdded,
      cartClicked: state => state.cart.cartClicked,
      cartProductsList: state => state.cart.cartProductsList,
      token: state => state.auth.token,
      mobile: state => state.navbar.mobile,
      itemDeletedLoading: state => state.cart.itemDeletedLoading,
      itemDeleted: state => state.cart.itemDeleted,
      windowWidth: state => state.navbar.windowWidth,
      activeProduct: state => state.products.activeProduct,
      activeQuantity: state => state.products.activeQuantity,
      loginModalVisibilityGlobal: state => state.navbar.loginModalVisibilityGlobal,
      registerModalVisibilityGlobal: state => state.navbar.registerModalVisibilityGlobal,
      productDetailImg: state => state.navbar.productDetailImg,
      productDetailImgVisibility: state => state.navbar.productDetailImgVisibility,
      warehouseSelectionModalVisibility: state => state.navbar.warehouseSelectionModalVisibility,
      orderModalVisible: state => state.orders.orderModalVisible,
      guestCheckoutModalVisiblity: state => state.navbar.guestCheckoutModalVisiblity,
      cartModalVisible: state => state.cart.cartModalVisible,
      shippingMethodGlobal: state => state.navbar.shippingMethodGlobal,
      zipcodeModalVisibility: state => state.navbar.zipcodeModalVisibility,
      shippingMethodModalVisibility: state => state.navbar.shippingMethodModalVisibility,
      shippingMethodModalVisibility_mobile: state => state.navbar.shippingMethodModalVisibility_mobile,
      userZip: state => state.navbar.userZip,
      wxModalVisible: state => state.navbar.wxModalVisible,
      deliveryList: state => state.navbar.deliverylist,
      mobileProductDetailsModalVisible: state => state.navbar.mobileProductDetailsModalVisible,
      companyId: state => state.products.companyId,
      warehouseId: state => state.products.warehouseId,
      userInfo: state => state.auth.userInfo,
      navGoId: state => state.navGoId,
      showProductsType1: state => state.showProductsType1,
      showProductsType2: state => state.showProductsType2,
      showProductsType3: state => state.showProductsType3,
      showList: state => state.showList,
      selectPrint: state => state.products.selectPrint,
      activeCardSelect: state => state.products.activeCardSelect,
      activeCardSelectPrint: state => state.products.activeCardSelectPrint,
      userDetails: state => state.auth.userDetails,
    }),
    showDeliveryList () {
      const { deliveryList, zipcode } = this
      if (!zipcode) {
        return deliveryList
      }
      return deliveryList.filter(item => item.zipcode.includes(zipcode))
    }
  },
  watch: {
    loggedIn: function (newVal, oldVal) {
      immediate: true
      if (oldVal === true && newVal === false) {
        this.$store.dispatch('cart/deleteLocalCart')
      } else if (oldVal === false && newVal === true) {
        this.cartProducts.map(localCartItem => {
          this.throttleAddToCart(localCartItem)
        })
      }
    },
    userInfo: function (newVal, oldVal) {
      immediate: true
      if (newVal) {
        // 登录时根据不同的用户显示固定的公司和仓库
        this.companyAll.forEach(item => {
          if (item.id == this.userInfo.Company_id) {
            return this.company_id = this.userInfo.Company_id
          }
        })
        //是否可以修改公司
        this.company_disabled = true
        if (this.userInfo.is_all_company) {
          this.company_disabled = false
        }
      }
    },
    showModal: function (newVal, oldVal) {
      if (newVal === true) {
        document.documentElement.style.overflow = 'hidden'
        return
      } else {
        document.documentElement.style.overflow = 'auto'
      }
    },
    token: function (newVal, oldVal) {
      immediate: true
      if (newVal !== null || newVal !== undefined) {
        this.local = false
        this.$store.dispatch('cart/getCart')
      } else {
        this.local = true
        this.$store.dispatch('cart/fetchCartProducts')
      }
    },
    itemCount: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart')
        } else {
          this.$store.dispatch('cart/fetchCartProducts')
        }
      }
    },
    addToCartSuccessful: function (newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        setTimeout(() => {
          this.resetAddToCartSuccess()
        }, 4000)
      }
    },
    allGroups: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        let cascadeOptions = []
        newVal.map(group => {
          let groupObj = {}
          groupObj.value = group.ProductGroup_id
          groupObj.label = group.Name
          groupObj.group = true
          groupObj.children = []
          groupObj.description = group.Description
          if (group.Categories.length > 0) {
            group.Categories.map(category => {
              let catObj = {}
              catObj.label = category.Name
              catObj.value = category.ProductCategory_id
              catObj.group = false
              catObj.parentValue = group.ProductGroup_id
              catObj.parentName = group.Name
              catObj.description = category.Description
              groupObj.children.push(catObj)
            })
          }
          cascadeOptions.push(groupObj)
        })
        //处理分类数据
        let array1 = []
        let array2 = []
        let allValue1 = []
        let allValue2 = []
        cascadeOptions.forEach(item => {
          if (item.value === 5) {
            //value是多个
            allValue2.push(item.value)
            array2.push(item)
          } else {
            //value是多个
            allValue1.push(item.value)
            array1.push(item)
          }
        })
        let arrayAll = []
        arrayAll[0] = {
          children: array1,
          description: "ALL Groceries",
          group: true,
          label: "ALL Groceries",
          value: [...allValue1]
        }
        // arrayAll[1] = {
        //   children: array2,
        //   description: "Beauty & Health & Home",
        //   group: true,
        //   label: "Beauty & Health & Home",
        //   value: [...allValue2]
        // }
        this.groupOptions = arrayAll
      }
    },
    $route (to, from) {
      if (this.$router.currentRoute.path === '/purchase') {
        this.topDisabled = true
      } else {
        this.topDisabled = false
      }
      if (!localStorage.getItem('shippingMethodGlobal')) {
        this.updateShippingMethodGlobal('Delivery')
      }
      if (this.$router.currentRoute.path === '/') {
        this.showNavBottom = false
      } else {
        this.showNavBottom = true
      }
    },
    loginModalVisibilityGlobal: function (newVal, oldVal) {
      // if (newVal !== oldVal) {
      this.loginModalVisibilityLocal = newVal
      // }
    },
    registerModalVisibilityGlobal: function (newVal, oldVal) {
      // if (newVal !== oldVal) {
      this.registerModalVisibilityLocal = newVal
      // }
    },
    homeWithinRadius: function (newVal, oldVal) {
      if (newVal === false) {
        this.$router.push('/')
        setTimeout(() => {
          this.$root.externalSetOops()
        }, 500)
      }
    },
    warehouseSelectionModalVisibility: function (newVal, oldVal) {
      if (newVal === true) {
        this.storeValue = localStorage.getItem('warehouseLocationWeb')
      }
    },
    mobileProductDetailsModalVisible: function (newVal, oldVal) {
      const el = document.documentElement
      if (newVal) {
        el.style.overflow = 'hidden'
        el.style.position = 'relative'
        el.style.width = 'calc(100% - 17px)'
        return
      }
      el.style.overflow = null
      el.style.position = null
      el.style.width = null
    },
    company_id: function (newVal, oldVal) {
      if (newVal) {
        this.changeCompanyId(this.company_id)
        //根据公司的id获取仓库
        this.getWarehouseByCompany(this.company_id)
          .then(res => {
            this.warehouseAll = res.data
            this.warehouseAll.forEach(item => {
              if (item.is_default) {
                this.warehouse_id = item.id
                this.changeWarehouseId(this.warehouse_id)
              }
            })
          }).catch(err => {
            console.log('err brand', err)
          })
      }
    },
  }
}
</script>

<style lang="less">
@import "../assets/css/modalNew.less";
@import "../assets/css/navbar.less";
@import "../assets/css/public.less";
@import "../assets/css/productPrintCard.less";
@import "../assets/css/cartContainer.less";
@import "../assets/query/navbar.less";

.icon-a
.unroll-enter-active,
.unroll-leave-active {
  transition: opacity 0.5s;
}

.unroll-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.unroll-enter,
.unroll-leave-to {
  opacity: 0;
}

.rotate-enter-active .rotate-leave-active {
  transform: rotate(0.5turn);
}

.rotate {
  transform: rotateZ(90deg);
  transition: all 0.5s ease-out;
}

.rotate-back {
  transform: rotateZ(0);
  transition: all 0.5s ease-out;
}

.account-portal-modal {
  background-color: #f8f8f8;
  border-radius: 5px;
  width: 200px;
  height: 270px;
  text-align: center;
  padding: 20px;
  padding-top: 0;
  position: absolute;
  box-shadow: 1px 10px 15px rgba(0, 0, 0, 0.2);
  z-index: 7;
}

.modal-data-container {
  display: block;
  text-align: left;

  .usernameDisplayInBuble {
    color: grey;
    cursor: pointer;
    padding: 12px 0;
    font-size: 70%;
  }

  .portal-links-container {
    padding: 20px 0;

    .each-link {
      line-height: 30px;
      cursor: pointer;
    }
  }

  .logout {
    cursor: pointer;
  }
}

.cart-container {
  position: relative;
  display: inline-block;
}

.cart-icon {
  font-size: 24px;
}

.cart-count {
  position: absolute;
  top: -5px;
  right: -10px;
  background: red;
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 50%;
  min-width: 18px;
  text-align: center;
}
.arrow {
  position: inherit;
  border-style: dashed;
  border-color: transparent;
  border-width: 0.2em;
  display: -moz-inline-box;
  display: inline-block;
  /* Use font-size to control the size of the arrow. */
  font-size: 50px;
  height: 0;
  line-height: 0;
  position: relative;
  vertical-align: middle;
  width: 0;
  background-color: transparent;
  /* change background color acc to bg color */
  border-bottom-width: 0.2em;
  border-bottom-style: solid;
  border-bottom-color: #f8f8f8;
  bottom: 0.25em;
  top: -23px;
  left: 50px;
  z-index: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue